export const searchUrlChangedEvent = 'searchUrlChanged';

export const dispatchUrlChangedEvent = () => {
  document.dispatchEvent(new CustomEvent(searchUrlChangedEvent));
};
